export const MENU_ALL = 0 // 全部
export const MENU_NOT_CLASSIFY = -1 // 未分类
